import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'AdditionAndSubtraction',
  field: 'Number',
  weeks: [5, 7],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      smallStep: 'AddAndSubtract1s10s100sAnd1000s',
      questionTypes: ['ahO', 'ahP', 'ahQ2', 'ahR', 'ahS', 'ahT'],
      archivedQuestionTypes: ['ahQ'],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/1AddAndSubtract1s10s100sAnd1000s" */ './1AddAndSubtract1s10s100sAnd1000sModels'
        )
    }),
    // Step 2
    newSmallStepContent({
      smallStep: 'AddUpToTwo4DigitNumbersNoExchange',
      questionTypes: ['ahU', 'ahV', 'ahW', 'ahX', 'ahY', 'ahZ'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/2AddUpToTwo4DigitNumbersNoExchange" */ './2AddUpToTwo4DigitNumbersNoExchangeModels'
        )
    }),
    // Step 3
    newSmallStepContent({
      smallStep: 'AddTwo4DigitNumbersOneExchange',
      questionTypes: ['ah0', 'ah1', 'ah2', 'ah3', 'ah4', 'ah5'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/3AddTwo4DigitNumbersOneExchange" */ './3AddTwo4DigitNumbersOneExchangeModels'
        )
    }),
    // Step 4
    newSmallStepContent({
      smallStep: 'AddTwo4DigitNumbersMoreThanOneExchange',
      questionTypes: ['ah6', 'ah7', 'ah8', 'ah9', 'aia', 'aib'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/4AddTwo4DigitNumbersMoreThanOneExchange" */ './4AddTwo4DigitNumbersMoreThanOneExchangeModels'
        )
    }),
    // Step 5
    newSmallStepContent({
      smallStep: 'SubtractTwo4DigitNumbersNoExchange',
      questionTypes: ['aic', 'aid', 'aie', 'aif', 'aig', 'aih'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/5SubtractTwo4DigitNumbersNoExchange" */ './5SubtractTwo4DigitNumbersNoExchangeModels'
        )
    }),
    // Step 6
    newSmallStepContent({
      smallStep: 'SubtractTwo4DigitNumbersOneExchange',
      questionTypes: ['aii', 'aij', 'aik', 'ail', 'aim', 'ain'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/6SubtractTwo4DigitNumbersOneExchange" */ './6SubtractTwo4DigitNumbersOneExchangeModels'
        )
    }),
    // Step 7
    newSmallStepContent({
      smallStep: 'SubtractTwo4DigitNumbersMoreThanOneExchange',
      questionTypes: ['aio', 'aip', 'aiq', 'air', 'ais', 'ait'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/7SubtractTwo4DigitNumbersMoreThanOneExchange" */ './7SubtractTwo4DigitNumbersMoreThanOneExchangeModels'
        )
    }),
    // Step 8
    newSmallStepContent({
      smallStep: 'EfficientSubtraction',
      questionTypes: ['aiu', 'aiv', 'aiw', 'aix', 'aiy', 'aiz'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/8EfficientSubtraction" */ './8EfficientSubtractionModels'
        )
    }),
    // Step 9
    newSmallStepContent({
      smallStep: 'EstimateAnswers',
      questionTypes: ['aiA', 'aiB', 'aiC', 'aiD', 'aiE', 'aiF'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/9EstimateAnswers" */ './9EstimateAnswersModels'
        )
    }),
    // Step 10
    newSmallStepContent({
      smallStep: 'CheckingStrategies',
      questionTypes: ['aiG', 'aiH', 'aiI', 'aiJ', 'aiK', 'aiL'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/AdditionAndSubtraction/10CheckingStrategies" */ './10CheckingStrategiesModels'
        )
    })
  ]
});
export default Block;
